<template>
  <v-card color="purple">
    <v-list-item>
      <v-list-item-avatar><v-icon>mdi-account</v-icon></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ getName }}</v-list-item-title>
        <v-list-item-subtitle
          ><b>Age</b>: {{ getAge }}, <b>Phone</b>:
          {{ getPhone }}</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "User",
  components: {},
  props: {
    name: { type: String, default: "" },
    age: { type: Number, default: "" },
    phone: { type: String, default: "" },
  },
  computed: {
    getName() {
      return this.name;
    },
    getAge() {
      return this.age;
    },
    getPhone() {
      return this.phone;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
